import { useGetDurationMetrics } from '@actions';
import { DurationCard, SectionHeading } from './common';

const TimingsTab = (props: { month: string }) => {
  const { data: durationMetrics } = useGetDurationMetrics({ month: props.month });

  return (
    <section className="flex flex-col gap-4">
      <SectionHeading
        title="Average timings"
        description="How long each step of the student journey takes, for the selected month."
      />
      <div className="grid grid-cols-1 gap-4 tablet:grid-cols-2">
        <DurationCard
          from="Payment"
          to="Mentor allocation"
          stat={durationMetrics?.paymentToAllocation}
        />
        <DurationCard
          from="Allocation"
          to="First session"
          stat={durationMetrics?.allocationToFirstSession}
        />
      </div>
    </section>
  );
};

export default TimingsTab;
